import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { sendSignInLink, logout } from "./authApi";

const initialState = {
  status: "idle",
};

export const sendSignInLinkAsync = createAsyncThunk(
  "auth/sendSignInLinkAsync",
  async ({ auth, email, actionCodeSettings }) => {
    await sendSignInLink(auth, email, actionCodeSettings);

    return { emailForSignIn: email };
  }
);

export const logoutAsync = createAsyncThunk(
  "auth/logoutAsync",
  async ({ auth }) => {
    await logout(auth);
    return;
  }
);

export const setAuthErrorAsync = createAsyncThunk(
  "auth/setAuthErrorAsync",
  async ({ code, message }) => {
    return { code, message };
  }
);

export const resetEmailLinkSentAsync = createAsyncThunk(
  "auth/resetEmailLinkSentAsync",
  async () => {
    return;
  }
);

export const setEmailForTOTPAsync = createAsyncThunk(
  "auth/setEmailForTOTPAsync",
  async ({ email }) => {
    return { email };
  }
);

export const resetEmailForTOTPAsync = createAsyncThunk(
  "auth/resetEmailForTOTPAsync",
  async () => {
    return;
  }
);

export const setEmailCodeSentAsync = createAsyncThunk(
  "auth/setEmailCodeSentAsync",
  async () => {
    return;
  }
);

export const resetEmailCodeSentAsync = createAsyncThunk(
  "auth/resetEmailCodeSentAsync",
  async () => {
    return;
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendSignInLinkAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(sendSignInLinkAsync.fulfilled, (state, action) => {
        state.emailLinkSent = true;
        state.status = `idle`;
      })
      .addCase(sendSignInLinkAsync.rejected, (state) => {
        state.status = `idle`;
      })
      .addCase(logoutAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(logoutAsync.fulfilled, (state) => {
        state.status = `idle`;
      })
      .addCase(logoutAsync.rejected, (state) => {
        state.status = `idle`;
      })
      .addCase(setAuthErrorAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(setAuthErrorAsync.fulfilled, (state, action) => {
        state.error = {
          code: action.payload.code,
          message: action.payload.message,
        };
        state.status = `idle`;
      })
      .addCase(setAuthErrorAsync.rejected, (state) => {
        state.error = {
          code: "auth/unknown",
          message: "Could not log you in, please try again.",
        };
        state.status = `idle`;
      })
      .addCase(resetEmailLinkSentAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(resetEmailLinkSentAsync.fulfilled, (state) => {
        state.emailLinkSent = false;
        state.status = `idle`;
      })
      .addCase(setEmailCodeSentAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(setEmailCodeSentAsync.fulfilled, (state) => {
        state.emailCodeSent = true;
        state.status = `idle`;
      })
      .addCase(setEmailForTOTPAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(setEmailForTOTPAsync.fulfilled, (state, action) => {                
        if (action && action.payload) {
          state.emailForTOTP = action.payload.email;
        }
              
        state.status = `idle`;
      })
      .addCase(resetEmailForTOTPAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(resetEmailForTOTPAsync.fulfilled, (state) => {
        state.emailForTOTP = undefined;
        state.status = `idle`;
      })
      .addCase(resetEmailCodeSentAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(resetEmailCodeSentAsync.fulfilled, (state) => {
        state.emailCodeSent = undefined;
        state.status = `idle`;
      })
  },
});

export default authSlice.reducer;
